module.exports = __webpack_public_path__ + "media/images/partners/boa-4c9b348134af3a8490619936cda7385e.png";